import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

import { authApi } from '../../api/endpoints';
import PasswordFields from '../../components/PasswordFields';
import Icon from '../../components/Icon';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const token = params.get('token');
  const email = params.get('email');

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: { password: '', confirmPassword: '' } });

  // A link missing its parameters cannot work, so say so rather than showing a
  // form that is guaranteed to fail.
  if (!token || !email) {
    return (
      <div className="auth-shell">
        <div className="auth-card" style={{ textAlign: 'center' }}>
          <div
            className="auth-logo"
            style={{ margin: '0 auto 18px', background: 'var(--danger-bg)', color: 'var(--danger-fg)', boxShadow: 'none' }}
          >
            <Icon name="link_off" style={{ fontSize: 24 }} />
          </div>
          <h1 className="auth-title">This link is not valid</h1>
          <p className="auth-sub">The reset link is incomplete. Request a new one and try again.</p>
          <Link to="/forgot-password" className="btn-brand" style={{ width: '100%', justifyContent: 'center' }}>
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  const onSubmit = async (values) => {
    setError(null);
    try {
      await authApi.resetPassword({
        token,
        email,
        password: values.password,
        confirmPassword: values.confirmPassword,
      });
      toast.success('Password updated. Sign in with your new password.');
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <img className="auth-logo-img" src="/photos/logo.png" alt="My Desi Guru" />
        <h1 className="auth-title">Set a new password</h1>
        <p className="auth-sub">for {email}</p>

        {error && (
          <div
            role="alert"
            style={{
              background: 'var(--danger-bg)',
              color: 'var(--danger-fg)',
              padding: '11px 14px',
              borderRadius: 'var(--radius)',
              fontSize: 13,
              fontWeight: 600,
              marginBottom: 18,
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <PasswordFields register={register} errors={errors} watch={watch} />

          <button type="submit" className="btn-brand" style={{ width: '100%', justifyContent: 'center' }} disabled={isSubmitting}>
            {isSubmitting && <span className="spinner" />}
            Update password
          </button>

          <div style={{ textAlign: 'center', marginTop: 18 }}>
            <Link to="/login" style={{ fontSize: 12, fontWeight: 600 }}>
              Back to sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
